const GrayBackground = () => {
    return(
        <div className="absolute bg-main-bg w-full h-full opacity-30 grayscale -z-10"/>
    )
};

export default GrayBackground;